import { Container, Grid } from "@mui/material";
import "./Header.scss";
import { useAppContext } from "./context";

const HeaderComponent = () => {
  const {appName, appNameLoaded} = useAppContext();
  return (
    <header
      className="nhsuk-header"
      role="banner"
      style={{
        background: "#005EB8",
        width: "auto",
        alignItems: "center",
        display: "flex",
        justifyContent: "flex-start",
        borderBottom: "1px solid rgba(255,255,255,.2)",
        height: "52px",
      }}
    >
      <Container style={{ justifyContent: "center", maxWidth: "1024px"}}>
        <Grid container alignContent={"center"} justifyContent={"space-between"} alignItems={"center"}>
          <Grid item>
            <div
              className="nhsuk-header__content"
              id="content-header"
              style={{ alignItems: "center", color: "white", fontSize: "1rem" }}
            >
              {appNameLoaded && (
                <>
                  {document.body.offsetWidth <= 900 && <>{appName[1]}</>}
                  {document.body.offsetWidth > 900 && (
                    <>{appName[0]}</>
                  )}
                </>
              )}
            </div>
          </Grid>
          {window.location.href.indexOf('login') == -1 &&  (
          <Grid item>
            <a className={"nhsuk-header__navigation-link"} href={process.env.REACT_APP_API_URL + "logout"}>Logout</a>
          </Grid>)}
        </Grid>
      </Container>
    </header>
  );
};

export default HeaderComponent;
